<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link fles-center flex-column"
        to="/"
      >
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo" /> -->
        <el-avatar v-if="logo" :size="avatarSize" :src="logo"></el-avatar>
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </router-link>
      <router-link
        v-else
        key="expand"
        class="sidebar-logo-link flex-center flex-column"
        to="/"
      >
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo" /> -->
        <el-avatar v-if="logo" :size="avatarSize" :src="logo"></el-avatar>
        <h1 class="sidebar-title">{{ title }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
const logo = require("@/assets/images/logo_2@2x.png");
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // logo: "https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png",
      logo: logo,
      avatarSize: 80,
    };
  },
  computed: {
    title() {
      return this.$store.state.settings.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  // height: 50px;
  // line-height: 50px;
  // background: #2b2f3a;
  padding-top: 47px;
  text-align: center;
  overflow: hidden;
  .flex-center {
    display: flex !important;
  }
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 100px;
      // height: 32px;
      vertical-align: middle;
      // margin-right: 12px;
    }
    ::v-deep .el-avatar {
      background-color: #fff;
      & > img {
        display: inline-block !important;
        height: 80%;
      }
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      // line-height: 50px;
      // font-size: 14px;
      font-size: 16px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;

      border: 1px solid #2784ce;
      margin-top: 18px;
      padding: 10px 20px;
      border-radius: 20px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
